import { render, staticRenderFns } from "./WorkflowList.vue?vue&type=template&id=6d950ca1&scoped=true"
import script from "./WorkflowList.vue?vue&type=script&lang=js"
export * from "./WorkflowList.vue?vue&type=script&lang=js"
import style0 from "./WorkflowList.scss?vue&type=style&index=0&id=6d950ca1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d950ca1",
  null
  
)

export default component.exports